import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { SRLWrapper } from 'simple-react-lightbox';
import { context } from '../../../../globalState/GlobalState';
import './css/ImageWithTitleComponent2.css';
import { isValidObject, isValidString } from '../../../../catalog/Validity';

const ImageWithTitleComponent2 = (props) => {
    const { title, image, alt } = props;
    const { globalState } = useContext(context);

    const options = {
        buttons: {
            showFullscreenButton: false,
            showDownloadButton: false,
            showAutoplayButton: false,
        },
        // thumbnails: {
        //     showThumbnails: false,
        // },
    };

    return (
        <>
            {isValidString(image) ? (
                <div className="image-with-title-component2 curve-border-15px">
                    <SRLWrapper options={options}>
                        <a href={image}>
                            <img className="image-with-title-component2-image" src={image} alt={title || alt} />
                        </a>
                    </SRLWrapper>
                    <div className="image-with-title-component2-text-container">
                        <p className="image-with-title-component2-text alegreya-font-family font-size-2xl font-weight-800 text-left-align font-spacing-wider m-t-0 m-b-0">{title}</p>
                        {isValidObject(globalState.silhouetteLogo) && isValidString(globalState.silhouetteLogo.logo3) ? (<img className="image-with-title-component2-logo" src={globalState.silhouetteLogo.logo3} alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />) : null}
                    </div>
                </div>
            ) : null}
        </>
    );
};

ImageWithTitleComponent2.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
};

export default memo(ImageWithTitleComponent2);
